const state = require('./state.js');
const ui = require('../ui');
const insured = require('../insured/index.js');
const DOM = require('./dom.js');
const moment = require('moment');
const { useDisableSpace, useFocus, useVisibility, useValidation, useTooltip, useKeys } = require('../common.js');

export const init = async () => {
    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;
    try {
        let response = await fetch(`${process.env.API_URL}/api/rcapolicy/vehicle/class?requestId=${ui.state.flowId}`, {});
        if (!response.ok)
            throw new Error('could not retrieve vehicle classes');
        let json = await response.json();
        state.classes = json;

        ui.state.isLoading = false;
        setTimeout(() => {
            DOM.txtVehicleVin.focus();
        }, 600);
    } catch (err) {
        ui.state.isLoading = false;
        window.location = '/error';
    }
};

//functions
const findVIN = async value => {
    let vin = value;
    if (!vin || vin.length < 17)
        return;

    vin = vin.toUpperCase();
    state.inProgress = true;
    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;
    try {
        await new Promise(resolve => setTimeout(resolve, 600));
        let response = await fetch(`${process.env.API_URL}/api/rcapolicy/vin/${vin}?requestId=${ui.state.flowId}`, {});
        let json;
        if (response.ok)
            json = await response.json();

        state.brands = [];
        state.models = [];
        state.class = '-1';
        state.brand = '-1';
        state.model = 'Alege model';
        state.maxWeight = '';
        state.year = '';
        state.seatNo = '';
        state.enginePower = '';
        state.engineDisplacement = '';
        state.energySource = '-1';

        let allValid = false;
        
        if ((!json || json.drpcivTicket === "00000000-0000-0000-0000-000000000000") && state.isFirstVinEmptyResponse) {
            ui.showInfo('Serie de șasiu neidentificată! Înainte de a continua te rugăm să verifici corectitudinea seriei de șasiu!')
        }
        if (json && json.vehicleClass) {
            state.class = json.vehicleClass;
            ddlClass.state.visible = false;

            state.brands = await fetchBrands(state.class);
            if (json.vehicleBrand) {
                if (json.vehicleBrand.startsWith('-')) {
                    let brand = state.brands.find(x => x.Name === json.vehicleBrandName);
                    if (brand) {
                        state.brand = brand.Id;
                        ddlBrand.state.visible = false;

                        state.models = await fetchModels(state.brand);
                    } else {
                        state.brand = '-1';
                        ddlBrand.state.visible = true;
                    }
                } else {
                    state.brand = json.vehicleBrand;
                    ddlBrand.state.visible = false;

                    state.models = await fetchModels(state.brand);
                }

                allValid = true;

                if (state.brand && state.brand!=='-1' && json.vehicleType && json.vehicleType.length > 0 && json.vehicleType !== '0') {
                    state.model = json.vehicleType;
                    ddlModel.state.visible = false;
                }
                else {
                    ddlModel.state.visible = true;
                    allValid = false;
                }
                
                if (json.vehicleMaxWeight && json.vehicleMaxWeight.length > 0 && json.vehicleMaxWeight !== '0') {
                    state.maxWeight = json.vehicleMaxWeight;
                    txtMaxWeight.state.visible = false;
                }
                else {
                    txtMaxWeight.state.visible = true;
                    allValid = false;
                }

                if (json.vehicleYear && json.vehicleYear.length > 0 && json.vehicleYear !== '0') {
                    state.year = json.vehicleYear;
                    txtYear.state.visible = false;
                }
                else {
                    txtYear.state.visible = true;
                    allValid = false;
                }

                if (json.vehicleSeatNo && json.vehicleSeatNo.length > 0 && json.vehicleSeatNo !== '0') {
                    state.seatNo = json.vehicleSeatNo;
                    txtSeatNo.state.visible = false;
                }
                else {
                    txtSeatNo.state.visible = true;
                    allValid = false;
                }

                if (json.vehicleEnginePower && json.vehicleEnginePower.length > 0 && json.vehicleEnginePower !== '0') {
                    state.enginePower = json.vehicleEnginePower;
                    txtEnginePower.state.visible = false;
                }
                else {
                    txtEnginePower.state.visible = true;
                    allValid = false;
                }

                if (json.vehicleEngineDisplacement && json.vehicleEngineDisplacement.length > 0 && json.vehicleEngineDisplacement !== '0') {
                    state.engineDisplacement = json.vehicleEngineDisplacement;
                    txtEngineDisplacement.state.visible = false;
                }
                else {
                    txtEngineDisplacement.state.visible = true;
                    allValid = false;
                }

                if (json.vehicleEnergySource && json.vehicleEnergySource.length > 0 && json.vehicleEnergySource !== 'Unknown') {
                    state.energySource = json.vehicleEnergySource;
                    ddlEnergySource.state.visible = false;
                }
                else {
                    ddlEnergySource.state.visible = true;
                    allValid = false;
                }

                if (json.vehiclePlateNo && json.vehiclePlateNo.length > 0 && json.vehiclePlateNo !== '0')
                    state.plateNo = json.vehiclePlateNo;
            } else {
                ddlBrand.state.visible = true;
                ddlModel.state.visible = true;
                txtMaxWeight.state.visible = true;
                txtYear.state.visible = true;
                txtSeatNo.state.visible = true;
                txtEngineDisplacement.state.visible = true;
                txtEnginePower.state.visible = true;
                ddlEnergySource.state.visible = true;
            }
        } else {
            ddlClass.state.visible = true;
            ddlBrand.state.visible = true;
            ddlModel.state.visible = true;
            txtMaxWeight.state.visible = true;
            txtYear.state.visible = true;
            txtSeatNo.state.visible = true;
            txtEngineDisplacement.state.visible = true;
            txtEnginePower.state.visible = true;
            ddlEnergySource.state.visible = true;
        }

        state.inProgress = false;
        ui.state.isLoading = false;

        if (allValid)
            DOM.btnVehicleNext.click();
    }
    catch (err) {
        ui.notyf.error('Ne pare rău, am întâmpinat o eroare');
        state.inProgress = false;
        ui.state.isLoading = false;
    }
};
const fetchBrands = async (classId) => {
    let response = await fetch(`${process.env.API_URL}/api/rcapolicy/vehicle/class/${classId}/brand?requestId=${ui.state.flowId}`, {});
    if (!response.ok)
        throw new Error('could not retrieve vehicle brands');

    let json = await response.json();
    return json;
};
const fetchModels = async (brandId) => {
    let response = await fetch(`${process.env.API_URL}/api/rcapolicy/vehicle/class/${state.class}/brand/${brandId}/model?requestId=${ui.state.flowId}`, {});
    if (!response.ok)
        throw new Error('could not retrieve vehicle models');

    let json = await response.json();
    return json;
};

//controls
let txtVin = useDisableSpace(useValidation(useFocus(DOM.txtVehicleVin)));
let ddlClass = useValidation(useVisibility(useFocus(DOM.ddlVehicleClass)));
let ddlBrand = useValidation(useVisibility(useFocus(DOM.ddlVehicleBrand)));
let ddlModel = useValidation(useVisibility(useFocus(DOM.ddlVehicleModel)));
let txtMaxWeight = useValidation(useVisibility(useFocus(DOM.txtVehicleMaxWeight)));
let txtYear = useValidation(useVisibility(useFocus(DOM.txtVehicleYear)));
let txtSeatNo = useValidation(useVisibility(useFocus(DOM.txtVehicleSeatNo)));
let txtEnginePower = useValidation(useVisibility(useFocus(DOM.txtVehicleEnginePower)));
let txtEngineDisplacement = useValidation(useVisibility(useFocus(DOM.txtVehicleEngineDisplacement)));
let ddlEnergySource = useValidation(useVisibility(useFocus(DOM.ddlVehicleEnergySource)));
useTooltip(DOM.btnVehicleVinTooltip);
useTooltip(DOM.btnVehicleTaxiTooltip);
useKeys(DOM.btnVehicleNext);
useKeys(DOM.btnVehicle1Back);
useKeys(DOM.btnVehicle1Next);

//bindings
state.bind('showPromoCar', v => {
    DOM.promoTextCar.style.display = v ? 'block' : 'none';
});
state.bind('inProgress', value => {
    // DOM.btnVehicleVinTooltip.classList[value ? 'add' : 'remove']('icon-pause-circle');
    // DOM.btnVehicleVinTooltip.classList[value ? 'remove' : 'add']('icon-info');

    DOM.txtVehicleVin.disabled = value;
    DOM.ddlVehicleClass.disabled = value;
    DOM.ddlVehicleBrand.disabled = value;
    DOM.ddlVehicleModel.disabled = value;
    DOM.txtVehicleMaxWeight.disabled = value;
    DOM.txtVehicleYear.disabled = value;
    DOM.txtVehicleSeatNo.disabled = value;
    DOM.txtVehicleEnginePower.disabled = value;
    DOM.txtVehicleEngineDisplacement.disabled = value;
    DOM.ddlVehicleEnergySource.disabled = value;
});
state.bind('class', DOM.ddlVehicleClass);
state.bind('brand', DOM.ddlVehicleBrand);
state.bind('model', DOM.ddlVehicleModel);
state.bind('maxWeight', DOM.txtVehicleMaxWeight);
state.bind('year', DOM.txtVehicleYear);
state.bind('seatNo', DOM.txtVehicleSeatNo);
state.bind('enginePower', DOM.txtVehicleEnginePower);
state.bind('engineDisplacement', DOM.txtVehicleEngineDisplacement);
state.bind('energySource', DOM.ddlVehicleEnergySource);
state.bind('classes', value => {
    DOM.ddlVehicleClass.innerHTML = '';

    for (const cls of [{ Id: '-1', Name: 'Alege clasa' }, { Id: '2001', Name: 'Autoturism' }, ...value.filter(x => x.Id !== '2001')]) {
        let option = document.createElement('option');
        option.value = cls.Id;
        option.innerText = cls.Name;
        DOM.ddlVehicleClass.appendChild(option);
    }
    state.class = '-1';
});
state.bind('brands', value => {
    DOM.ddlVehicleBrand.innerHTML = '';

    for (const brand of [{ Id: '-1', Name: 'Alege marca' }, ...value]) {
        let option = document.createElement('option');
        option.value = brand.Id;
        option.innerText = brand.Name;
        DOM.ddlVehicleBrand.appendChild(option);
    }
    state.brand = '-1';
    state.model = 'Alege model';
});
state.bind('models', value => {
    DOM.ddlVehicleModel.innerHTML = '';

    if (value.length === 1) {
        let option = document.createElement('option');
        option.value = value[0].Name;
        option.innerText = value[0].Name;
        DOM.ddlVehicleModel.appendChild(option);
        state.model = value[0].Name;
        return;
    }

    for (const model of [{ Id: '-1', Name: 'Alege model' }, ...value]) {
        let option = document.createElement('option');
        option.value = model.Name;
        option.innerText = model.Name;
        DOM.ddlVehicleModel.appendChild(option);
    }
    state.model = 'Alege model';
});
state.bind('isTaxi', value => {
    DOM.divTaxi.children[0].classList[value ? 'add' : 'remove']('active');
    DOM.divTaxi.children[1].classList[value ? 'remove' : 'add']('active');
});

//events
DOM.txtVehicleVin.addEventListener('change', async e => {
    let value = e.target.value;
    state.vin = value;
    state.isFirstVinEmptyResponse = true;
    await findVIN(value);
});
DOM.txtVehicleVin.addEventListener('keyup', async e => {
    let value = e.target.value;
    value = value.replace(/O/g, '0');
    value = value.replace(/o/g, '0');
    value = value.replace(/I/g, '1');
    value = value.replace(/i/g, '1');
    e.target.value = value;

    state.vin = value;
});
DOM.txtVehicleVin.addEventListener('keydown', async e => {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 13) //enter
        await findVIN(e.target.value);
});
DOM.ddlVehicleClass.addEventListener('change', async e => {
    const value = e.target.value;
    if (!value || value === '-1') {
        state.brands = [];
        state.models = [];
        return;
    }

    state.inProgress = true;
    try {
        state.brands = await fetchBrands(value);
        state.inProgress = false;
        state.models = [];
    } catch (err) {
        state.inProgress = false;
        ui.notyf.error('Ne pare rău, am întâmpinat o eroare');
        state.brands = [];
        state.models = [];
    }
});
DOM.ddlVehicleBrand.addEventListener('change', async e => {
    const value = e.target.value;
    if (!value || value === '-1') {
        state.models = [];
        return;
    }

    state.inProgress = true;
    try {
        state.models = await fetchModels(value);
        state.inProgress = false;
    } catch (err) {
        ui.notyf.error('Ne pare rău, am întâmpinat o eroare');
        state.inProgress = false;
        state.models = [];
    }
});
DOM.btnVehicleNext.addEventListener('click', (e) => {
    e.preventDefault();

    if (state.inProgress)
        return;

    txtVin.state.valid = true;
    ddlClass.state.valid = true;
    ddlBrand.state.valid = true;
    ddlModel.state.valid = true;
    txtMaxWeight.state.valid = true;
    txtYear.state.valid = true;
    txtSeatNo.state.valid = true;
    txtEnginePower.state.valid = true;
    txtEngineDisplacement.state.valid = true;
    ddlEnergySource.state.valid = true;

    let isValid = true;
    if (state.vin.trim().length === 0 || state.vin.trim().length !== 17) {
        txtVin.state.valid = false;
        isValid = false;
    }
    if (state.class === '-1') {
        ddlClass.state.valid = false;
        isValid = false;
    }
    if (state.brand === '-1') {
        ddlBrand.state.valid = false;
        isValid = false;
    }
    if (state.model === 'Alege model') {
        ddlModel.state.valid = false;
        isValid = false;
    }
    if (!state.maxWeight) {
        txtMaxWeight.state.valid = false;
        isValid = false;
    } else {
        let maxWeight = parseInt(state.maxWeight);
        if (maxWeight < 0 || maxWeight > 100000 || isNaN(maxWeight)) {
            txtMaxWeight.state.valid = false;
            isValid = false;
        }
    }
    if (!state.year) {
        txtYear.state.valid = false;
        isValid = false;
    } else {
        if (state.year.length !== 4) {
            txtYear.state.valid = false;
            isValid = false;
        }
        let year = parseInt(state.year);
        if (year < 1980 || year > moment().year() || isNaN(year)) {
            txtYear.state.valid = false;
            isValid = false;
        }
    }
    if (!state.seatNo) {
        txtSeatNo.state.valid = false;
        isValid = false;
    } else {
        let seatNo = parseInt(state.seatNo);
        if (seatNo > 100 || seatNo < 0 || isNaN(seatNo)) {
            txtSeatNo.state.valid = false;
            isValid = false;
        }
    }
    if (!state.enginePower) {
        txtEnginePower.state.valid = false;
        isValid = false;
    } else {
        let enginePower = parseInt(state.enginePower);
        if (enginePower < 0 || enginePower > 100000 || isNaN(enginePower)) {
            txtEnginePower.state.valid = false;
            isValid = false;
        }
    }
    if (!state.engineDisplacement) {
        txtEngineDisplacement.state.valid = false;
        isValid = false;
    } else {
        let engineDisplacement = parseInt(state.engineDisplacement);
        if (engineDisplacement < 0 || engineDisplacement > 100000 || isNaN(engineDisplacement)) {
            txtEngineDisplacement.state.valid = false;
            isValid = false;
        }
    }
    if (!state.energySource || state.energySource === '-1') {
        ddlEnergySource.state.valid = false;
        isValid = false;
    }

    if (!isValid)
        return;

    ui.state.slide = [1, 1];
});
DOM.divTaxi.children[0].addEventListener('click', e => {
    e.preventDefault();
    state.isTaxi = true;
});
DOM.divTaxi.children[1].addEventListener('click', e => {
    e.preventDefault();
    state.isTaxi = false;
});
DOM.btnVehicle1Back.addEventListener('click', () => {
    ui.state.slide = [1, 0];
});
DOM.btnVehicle1Next.addEventListener('click', () => {
    insured.init();
    ui.state.slide = [1, 2];
});

module.exports.state = state;
module.exports.DOM = DOM;